import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Flex } from '@stepstone-genesis/components';
import { HeadingWithText } from './components/HeadingWithText.js';
import { InputWithButton } from './components/InputWithButton.js';
import { AppleUpdateFailedAlert } from './components/AppleUpdateFailedAlert.js';
import { useAppDispatch } from '../../redux/hooks.js';
import { authSuccessThunk } from '../../redux/core/authSuccess/authSuccessSlice.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
export const AppleUpdateEmail = () => {
    const dispatch = useAppDispatch();
    const { trackModalComponentVisible } = useTrack('twoStep');
    useEffect(() => {
        trackModalComponentVisible();
        return () => {
            dispatch(authSuccessThunk('apple', null, {
                apple: {
                    skipEmailUpdate: true,
                },
            }));
        };
    }, []);
    return (_jsxs(Flex, { flxDirection: 'column', gap: 'spaceL', "data-testid": "apple-update-email", children: [_jsx(AppleUpdateFailedAlert, {}), _jsxs(Flex, { flxDirection: 'column', gap: ['spaceL', 'spaceL', 'spaceXl'], children: [_jsx(HeadingWithText, {}), _jsx(InputWithButton, {})] })] }));
};
//# sourceMappingURL=AppleUpdateEmail.js.map